import { setByPath } from "../../../../Routes/RenderPdf/dataPaths";

export function setValueAtPath(state, payload) {
  if (!payload || payload.path == null) return {};
  return {
    data: setByPath(state.data, payload.path, payload.value),
    dirty: true,
  };
}
